import { canNavigate, ConductorOneChildActive, Router, ScreenBase, splitUrlSegments } from "@frui.ts/screens";
import LocalizationService from "services/localizationService";
import { Notice } from "../../../services/NIA/niaService";
import NoticeEntity from "../../../models/notice";
import RefundRequestViewModel, { RefundRequestNavigationName } from "./refundRequestViewModel";
import RefundRequestDocumentsUploadedViewModel, {
  RefundRequestDocumentsUploadedViewModelNavigationName,
} from "./refundRequestDocumentsUploadedViewModel";

export const RefundModuleNavigationName = "refund_request";

@Router.registerRoute({
  route: RefundModuleNavigationName,
  name: Router.Self,
  children: [RefundRequestViewModel, RefundRequestDocumentsUploadedViewModel],
})
export default class RefundRequestNoticeViewModel extends ConductorOneChildActive<ScreenBase> {
  constructor(
    private documentsVMFactory: ReturnType<typeof RefundRequestDocumentsUploadedViewModel.Factory>,
    public localizationService: LocalizationService,
    private refundRequestViewModel: RefundRequestViewModel
  ) {
    super();
    this.nameValue = "refundRequest.title";
    this.navigationName = RefundModuleNavigationName;
    this.children.push(this.refundRequestViewModel);
  }

  onInitialize() {
    return this.tryActivateChild(this.refundRequestViewModel);
  }

  async navigate(subPath: string | undefined, params: any) {
    const segments = splitUrlSegments(subPath);
    let childToActivate;
    if (segments[0] === RefundRequestDocumentsUploadedViewModelNavigationName) {
      childToActivate = await this.findNavigationChild(subPath || "");
    } else if (segments[0] === RefundRequestNavigationName) {
      childToActivate = await this.findNavigationChild(subPath || "");
    }

    if (childToActivate) {
      await this.tryActivateChild(childToActivate);

      if (canNavigate(childToActivate)) {
        await childToActivate.navigate(segments[1], params);
      }
    }

    await this.onChildNavigated(childToActivate);
  }

  async findNavigationChild(navigationName: string) {
    if (navigationName.includes(RefundRequestDocumentsUploadedViewModelNavigationName)) {
      const noticeString = sessionStorage.getItem(Notice.REFUND_REQUEST);

      if (noticeString) {
        const notice = JSON.parse(noticeString) as NoticeEntity;

        if (notice._noticeBase64) {
          return this.documentsVMFactory(notice._noticeBase64, Notice.REFUND_REQUEST);
        }
      }
    }
    return super.findNavigationChild(navigationName);
  }
}
